import { render, staticRenderFns } from "./HMIPageAttrs.vue?vue&type=template&id=64cdd66c"
import script from "./HMIPageAttrs.vue?vue&type=script&lang=js"
export * from "./HMIPageAttrs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports